const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "EUR",
}).format;

export function formatCurrency(value: number): string {
  return formatter(Math.ceil(value / 100) * 100).slice(0, -3);
}
